import React, { useEffect, useState } from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import Input from 'components/forms/Input'
import { StyledFieldSet, StyledLegend, StyledSpan } from 'components/StyledElements'
import { Button, Grid, Stack } from '@mui/material'
import Select from 'components/forms/Select'
import { CardTable } from '../../../components/datatable/NewTable'
import RadioButtons from 'components/forms/RadioButtons'
import { shallowEqual, useSelector } from 'react-redux'
import { CITIES, STATIONS, DEPARTMENTS } from 'traitements/constants/TraitementConstants'
import { exportFile } from '../../../utils/ExportDataUtil'
import { uniq } from 'lodash'
import { readImportCsvStationsCodes } from '../../../import/components/utils/ImportUtils'

const AddPluvioStepOptionsTreatmentArea = ({
    changeFilters,
    filters = {},
    newJob,
    setNewJob,
    listStation,
    setListStation,
}) => {
    const {
        cities,
    } = useSelector(store => ({
        pluviometryDataTypes: store.PluviometryReducer.pluviometryDataTypes,
        cities: store.CityReducer.cities,
    }), shallowEqual)

    useEffect(() => {
        if (!filters?.stationsMode) {
            changeFilters({ stationsMode: CITIES })
        }
    }, [])

    const codesTypes = [
        { code: CITIES, name: i18n.cities },
        { code: STATIONS, name: i18n.watershedStations },
    ]


    const changeJob = (changes) => setNewJob({ ...newJob, ...changes })

    const [newCode, setNewCode] = useState('')
    const currentList = listStation.find(([key]) => key === filters.stationsMode)?.[1] ?? []

    const stationsCodes = currentList.map(code => ({ code }))

    const onDeletePluvioCode = ({ code }) => {
        const key = filters.stationsMode === DEPARTMENTS ? DEPARTMENTS : filters.stationsMode
        setListStation(prev =>
            prev.map(item => item[0] === key ? [item[0], item[1].filter(p => p !== code)] : item,
            ),
        )
    }
    const onChangeBssFile = e => {
        readImportCsvStationsCodes(e, { importFile: e.target }, (codes) => {
            const key = filters.stationsMode === DEPARTMENTS ? DEPARTMENTS : filters.stationsMode
            setListStation(prev =>
                prev.map(item =>
                    item[0] === key ? [item[0], uniq([...item[1], ...codes])]: item,
                ),
            )
        })
    }
    const handleAdd = () => {
        if (!newCode) return
        const key = filters.stationsMode === DEPARTMENTS ? DEPARTMENTS : filters.stationsMode
        setListStation(prev =>
            prev.map(item => {
                if (item[0] !== key) return item
                if (item[1].includes(newCode)) return item
                return [item[0], [...item[1], newCode]]
            }),
        )
        setNewCode('')
    }
    const isInputMode = [STATIONS, DEPARTMENTS].includes(filters.stationsMode)
    return (
        <>
            <StyledFieldSet>
                <StyledLegend>
                    <StyledSpan>{i18n.description}</StyledSpan>
                </StyledLegend>
                <Grid container mb={2} spacing={8}>
                    <Grid size={12}>
                        <Input
                            title={i18n.name}
                            obligatory
                            value={newJob.name}
                            onChange={v => changeJob({ name: v })}
                        />
                    </Grid>

                </Grid>
            </StyledFieldSet>
            <StyledFieldSet>
                <StyledLegend>
                    <StyledSpan>{i18n.options}</StyledSpan>
                </StyledLegend>
                <Grid container justifyContent='space-between' mb={2} spacing={2} >
                    <Grid size={5}>
                        <RadioButtons
                            elements={codesTypes}
                            selected={filters.stationsMode}
                            onChange={v => changeFilters({ stationsMode: v })}
                            title={i18n.schemeAgencyID}
                        />
                    </Grid>
                </Grid>
                <Grid container mb={2} spacing={8}>
                    <Grid size={6}>
                        {isInputMode ? (
                            <Input
                                id='txtAddHydroCode'
                                type='text'
                                value={newCode}
                                onChange={v => setNewCode(v)}
                                title={i18n.code}
                                obligatory
                                onEnterKeyPress={handleAdd}
                                noSpace
                            />
                        ) : (
                            <Select
                                label={i18n.city}
                                options={cities}
                                value={newCode}
                                onChange={v => setNewCode(v)}
                                keyValue='id'
                                displayWithCode
                            />
                        )}
                    </Grid>
                    <Grid container size={6} spacing={4}>
                        <Button
                            onClick={handleAdd}
                            variant='contained'
                        >
                            {i18n.add}
                        </Button>
                        <Button
                            variant='contained'
                            component='label'
                        >
                            {i18n.importLabelStation}
                            <input
                                type='file'
                                accept='.csv'
                                hidden
                                onChange={onChangeBssFile}
                            />
                        </Button>
                    </Grid>
                </Grid>
            </StyledFieldSet>
            <StyledFieldSet>
                <StyledLegend>
                    <StyledSpan>{i18n.parameters}</StyledSpan>
                </StyledLegend>
                <Stack spacing={4}>
                    <CardTable
                        headers={['code']}
                        rows={stationsCodes}
                        title={ filters.stationsMode === STATIONS ? i18n.credentials : i18n[filters.stationsMode] }
                        lineActions={[
                            { icon: 'delete', onClick: onDeletePluvioCode },
                        ]}
                        actions={[{
                            icon: 'download',
                            onClick: () => exportFile({
                                data: [{ ...(stationsCodes[0]), headers: ['code'] }, ...(stationsCodes.slice(1, stationsCodes.length))],
                                titleFile: i18n.credentials,
                            }),
                            tooltip: i18n.download,
                        }]}
                        displayHeaders={false}
                    />
                </Stack>
            </StyledFieldSet>
        </>

    )
}

AddPluvioStepOptionsTreatmentArea.propTypes = {
    jobDataTypes: PropTypes.arrayOf(PropTypes.string),
    setJobDataTypes: PropTypes.func,
    changeFilters: PropTypes.func,
    filters: PropTypes.shape({}),
    newJob: PropTypes.any,
    setNewJob: PropTypes.func,
    listStation: PropTypes.any,
    setListStation: PropTypes.func,
}

export default AddPluvioStepOptionsTreatmentArea